// Pagination

export const INDEX_PAGE_SIZE_DEFAULT = 50;
export const INDEX_PAGE_SIZE_OPTIONS = [5, 10, 20, 30, 50, 100];
export const SET_TRANSACTIONS_PAGE_SIZE = 'SET_TRANSACTIONS_PAGE_SIZE';

// Date const
export const SET_DATE_RANGE = 'SET_DATE_RANGE';

// Customizer const
export const TOGGLE_COLLAPSED_NAV = 'TOGGLE_COLLAPSE_MENU';
export const WINDOW_WIDTH = 'WINDOW-WIDTH';
export const SWITCH_LANGUAGE = 'SWITCH-LANGUAGE';
export const TOGGLE_ENVIRONMENT = 'TOGGLE_ENVIRONMENT';

// Contact Module const
export const FETCH_START = 'FETCH_START';
export const FETCH_SUCCESS = 'FETCH_SUCCESS';
export const FETCH_ERROR = 'FETCH_ERROR';
export const SHOW_MESSAGE = 'SHOW_MESSAGE';
export const SHOW_ERROR_MESSAGE = 'SHOW_ERROR_MESSAGE';
export const HIDE_MESSAGE = 'HIDE_MESSAGE';
export const ON_SHOW_LOADER = 'ON_SHOW_LOADER';
export const ON_HIDE_LOADER = 'ON_HIDE_LOADER';
export const CHANGE_PAGE_LIMIT = 'CHANGE_PAGE_LIMIT';
export const CHANGE_PAGE = 'CHANGE_PAGE';

// Auth const
export const SIGNUP_USER_SUCCESS = 'SIGNUP_USER_SUCCESS';
export const RESET_ENV_APP_STATE = 'RESET_ENV_APP_STATE';
export const ACTIVATE_USER_INIT = 'ACTIVATE_USER_INIT';
export const ACTIVATE_USER_SUCCESS = 'ACTIVATE_USER_SUCCESS';
export const ACTIVATE_USER_ERROR = 'ACTIVATE_USER_ERROR';
export const ACTIVATION_CODE_RECREATE_SUCCESS = 'ACTIVATION_CODE_RECREATE_SUCCESS';
export const SET_FORGOT_PASSWORD_EMAIL = 'SET_FORGOT_PASSWORD_EMAIL';
export const SIGNIN_GOOGLE_USER = 'SIGNIN_GOOGLE_USER';
export const SIGNIN_GOOGLE_USER_SUCCESS = 'SIGNIN_GOOGLE_USER_SUCCESS';
export const SIGNIN_FACEBOOK_USER = 'SIGNIN_FACEBOOK_USER';
export const SIGNIN_FACEBOOK_USER_SUCCESS = 'SIGNIN_FACEBOOK_USER_SUCCESS';
export const SIGNIN_TWITTER_USER = 'SIGNIN_TWITTER_USER';
export const SIGNIN_TWITTER_USER_SUCCESS = 'SIGNIN_TWITTER_USER_SUCCESS';
export const SIGNIN_GITHUB_USER = 'SIGNIN_GITHUB_USER';
export const SIGNIN_GITHUB_USER_SUCCESS = 'signin_github_user_success';
export const SIGNIN_USER = 'SIGNIN_USER';
export const SIGNIN_USER_SUCCESS = 'SIGNIN_USER_SUCCESS';
export const SIGNOUT_USER = 'SIGNOUT_USER';
export const SIGNOUT_USER_SUCCESS = 'SIGNOUT_USER_SUCCESS';
export const INIT_URL = 'INIT_URL';
export const USER_DATA = 'user_data';
export const SELECTED_USER_DATA = 'SELECTED_USER_DATA';
export const USER_TOKEN_SET = 'user_token_set';
export const PASSWORD_RESET_INIT = 'PASSWORD_RESET_INIT';
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';
export const PASSWORD_RESET_ERROR = 'PASSWORD_RESET_ERROR';

// QUEUE_MESSAGES
export const FETCH_QUEUE_MESSAGE_START = 'FETCH_QUEUE_MESSAGE_START';
export const FETCH_QUEUE_MESSAGE_SUCCESS = 'FETCH_QUEUE_MESSAGE_SUCCESS';
export const FETCH_QUEUE_MESSAGE_ERROR = 'FETCH_QUEUE_MESSAGE_ERROR';
export const QUEUE_MESSAGE_LOADING = 'QUEUE_MESSAGE_LOADING';

export const FETCH_QUEUE_MESSAGES_START = 'FETCH_QUEUE_MESSAGES_START';
export const FETCH_QUEUE_MESSAGES_SUCCESS = 'FETCH_QUEUE_MESSAGES_SUCCESS';
export const FETCH_QUEUE_MESSAGES_ERROR = 'FETCH_QUEUE_MESSAGES_ERROR';
export const QUEUE_MESSAGES_LOADING = 'QUEUE_MESSAGES_LOADING';

export const DELETE_QUEUE_MESSAGE_START = 'DELETE_QUEUE_MESSAGE_START';
export const DELETE_QUEUE_MESSAGE_SUCCESS = 'DELETE_QUEUE_MESSAGE_SUCCESS';
export const DELETE_QUEUE_MESSAGE_ERROR = 'DELETE_QUEUE_MESSAGE_ERROR';

// ROLES
export const FETCH_ROLES_START = 'FETCH_ROLES_START';
export const FETCH_ROLES_SUCCESS = 'FETCH_ROLES_SUCCESS';
export const FETCH_ROLES_ERROR = 'FETCH_ROLES_ERROR';

export const ADD_ROLE_START = 'ADD_ROLE_START';
export const ADD_ROLE_SUCCESS = 'ADD_ROLE_SUCCESS';
export const ADD_ROLE_ERROR = 'ADD_ROLE_ERROR';

export const UPDATE_ROLE_START = 'UPDATE_ROLE_START';
export const UPDATE_ROLE_SUCCESS = 'UPDATE_ROLE_SUCCESS';
export const UPDATE_ROLE_ERROR = 'UPDATE_ROLE_ERROR';

export const DELETE_ROLE_START = 'DELETE_ROLE_START';
export const DELETE_ROLE_SUCCESS = 'DELETE_ROLE_SUCCESS';
export const DELETE_ROLE_ERROR = 'DELETE_ROLE_ERROR';

// PROCESSING SUMMARY
export const FETCH_PROCESSING_SUMMARY_START = 'FETCH_PROCESSING_SUMMARY_START';
export const FETCH_PROCESSING_SUMMARY_ERROR = 'FETCH_PROCESSING_SUMMARY_ERROR';
export const FETCH_PROCESSING_SUMMARY_SUCCESS = 'FETCH_PROCESSING_SUMMARY_SUCCESS';
export const ADD_PROCESSING_SUMMARY_ERROR = 'ADD_PROCESSING_SUMMARY_ERROR';
export const ADD_PROCESSING_SUMMARY_START = 'ADD_PROCESSING_SUMMARY_START';
export const ADD_PROCESSING_SUMMARY_SUCCESS = 'ADD_PROCESSING_SUMMARY_SUCCESS';
export const DELETE_PROCESSING_SUMMARY_START = 'DELETE_PROCESSING_SUMMARY_START';
export const DELETE_PROCESSING_SUMMARY_SUCCESS = 'DELETE_PROCESSING_SUMMARY_SUCCESS';
export const DELETE_PROCESSING_SUMMARY_ERROR = 'DELETE_PROCESSING_SUMMARY_ERROR';
export const UPDATE_PROCESSING_SUMMARY_START = 'UPDATE_PROCESSING_SUMMARY_START';
export const UPDATE_PROCESSING_SUMMARY_SUCCESS = 'UPDATE_PROCESSING_SUMMARY_SUCCESS';
export const UPDATE_PROCESSING_SUMMARY_ERROR = 'UPDATE_PROCESSING_SUMMARY_ERROR';

// USERS
export const FETCH_USERS_START = 'FETCH_USERS_START';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_ERROR = 'FETCH_USERS_ERROR';
export const FETCH_MERCHANT_USERS_START = 'FETCH_MERCHANT_USERS_START';
export const FETCH_MERCHANT_USERS_SUCCESS = 'FETCH_MERCHANT_USERS_SUCCESS';
export const FETCH_MERCHANT_USERS_ERROR = 'FETCH_MERCHANT_USERS_ERROR';
export const UPDATE_USER_START = 'UPDATE_USER_START';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR';

export const ADD_USER_START = 'ADD_USER_START';
export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS';
export const ADD_USER_ERROR = 'ADD_USER_ERROR';

// PERMISSIONS
export const FETCH_PERMISSIONS_START = 'FETCH_PERMISSIONS_START';
export const FETCH_PERMISSIONS_SUCCESS = 'FETCH_PERMISSIONS_SUCCESS';
export const FETCH_PERMISSIONS_ERROR = 'FETCH_PERMISSIONS_ERROR';

export const ADD_PERMISSIONS_START = 'ADD_PERMISSIONS_START';
export const ADD_PERMISSIONS_SUCCESS = 'ADD_PERMISSIONS_SUCCESS';
export const ADD_PERMISSIONS_ERROR = 'ADD_PERMISSIONS_ERROR';

export const DELETE_PERMISSIONS_START = 'DELETE_PERMISSIONS_START';
export const DELETE_PERMISSIONS_SUCCESS = 'DELETE_PERMISSIONS_SUCCESS';
export const DELETE_PERMISSIONS_ERROR = 'DELETE_PERMISSIONS_ERROR';

export const UPDATE_PERMISSIONS_START = 'UPDATE_PERMISSIONS_START';
export const UPDATE_PERMISSIONS_SUCCESS = 'UPDATE_PERMISSIONS_SUCCESS';
export const UPDATE_PERMISSIONS_ERROR = 'UPDATE_PERMISSIONS_ERROR';
export const SET_SELECTED_USER = 'SET_SELECTED_USER';

// DATA ACTIONS //

// SETTLEMENTS
export const FETCH_SETTLEMENT_REPORT_SUMMARY_INIT = 'FETCH_SETTLEMENT_REPORT_SUMMARY_INIT';
export const FETCH_SETTLEMENT_REPORT_SUMMARY_SUCCESS = 'FETCH_SETTLEMENT_REPORT_SUMMARY_SUCCESS';
export const FETCH_SETTLEMENT_REPORT_SUMMARY_ERROR = 'FETCH_SETTLEMENT_REPORT_SUMMARY_ERROR';

// PROCESSING_TYPES
export const FETCH_PROCESSING_TYPES_INIT = 'FETCH_PROCESSING_TYPES_INIT';
export const FETCH_PROCESSING_TYPES_SUCCESS = 'FETCH_PROCESSING_TYPES_SUCCESS';
export const FETCH_PROCESSING_TYPES_ERROR = 'FETCH_PROCESSING_TYPES_ERROR';
export const CREATE_PROCESSING_TYPE_INIT = 'CREATE_PROCESSING_TYPE_INIT';
export const CREATE_PROCESSING_TYPE_SUCCESS = 'CREATE_PROCESSING_TYPE_SUCCESS';
export const CREATE_PROCESSING_TYPE_ERROR = 'CREATE_PROCESSING_TYPE_ERROR';
export const UPDATE_PROCESSING_TYPE_INIT = 'UPDATE_PROCESSING_TYPE_INIT';
export const UPDATE_PROCESSING_TYPE_SUCCESS = 'UPDATE_PROCESSING_TYPE_SUCCESS';
export const UPDATE_PROCESSING_TYPE_ERROR = 'UPDATE_PROCESSING_TYPE_ERROR';
export const DELETE_PROCESSING_TYPE_INIT = 'DELETE_PROCESSING_TYPE_INIT';
export const DELETE_PROCESSING_TYPE_SUCCESS = 'DELETE_PROCESSING_TYPE_SUCCESS';
export const DELETE_PROCESSING_TYPE_ERROR = 'DELETE_PROCESSING_TYPE_ERROR';

// MERCHANT ACCOUNTS

export const CREATE_MERCHANT_ACCOUNT_INIT = 'CREATE_MERCHANT_ACCOUNT_INIT';
export const CREATE_MERCHANT_ACCOUNT_SUCCESS = 'CREATE_MERCHANT_ACCOUNT_SUCCESS';
export const CREATE_MERCHANT_ACCOUNT_ERROR = 'CREATE_MERCHANT_ACCOUNT_ERROR';
export const SET_ACTIVE_MERCHANT_ACCOUNT = 'SET_ACTIVE_MERCHANT_ACCOUNT';
export const SET_SELECTED_MERCHANT_TYPE = 'SET_SELECTED_MERCHANT_TYPE';
export const SET_SELECTED_PROCESSING_TYPE = 'SET_SELECTED_PROCESSING_TYPE';
export const FETCH_MERCHANT_ACCOUNTS_INIT = 'FETCH_MERCHANT_ACCOUNTS_INIT';
export const FETCH_MERCHANT_ACCOUNTS_SUCCESS = 'FETCH_MERCHANT_ACCOUNTS_SUCCESS';
export const FETCH_MERCHANT_ACCOUNTS_ERROR = 'FETCH_MERCHANT_ACCOUNTS_ERROR';
export const FETCH_AFFILIATE_MERCHANT_ACCOUNTS_INIT = 'FETCH_AFFILIATE_MERCHANT_ACCOUNTS_INIT';
export const FETCH_AFFILIATE_MERCHANT_ACCOUNTS_SUCCESS = 'FETCH_AFFILIATE_MERCHANT_ACCOUNTS_SUCCESS';
export const FETCH_AFFILIATE_MERCHANT_ACCOUNTS_ERROR = 'FETCH_AFFILIATE_MERCHANT_ACCOUNTS_ERROR';
export const FETCH_SELECTED_MERCHANT_ACCOUNT = 'FETCH_SELECTED_MERCHANT_ACCOUNT';
export const SET_SELECTED_MERCHANT_ACCOUNT = 'SET_SELECTED_MERCHANT_ACCOUNT';
export const UPDATE_MERCHANT_ACCOUNT_INIT = 'UPDATE_MERCHANT_ACCOUNT_INIT';
export const UPDATE_MERCHANT_ACCOUNT_SUCCESS = 'UPDATE_MERCHANT_ACCOUNT_SUCCESS';
export const UPDATE_MERCHANT_ACCOUNT_ERROR = 'UPDATE_MERCHANT_ACCOUNT_ERROR';
export const ADD_MERCHANT_ACCOUNT_INIT = 'ADD_MERCHANT_ACCOUNT_INIT';
export const ADD_MERCHANT_ACCOUNT_SUCCESS = 'ADD_MERCHANT_ACCOUNT_SUCCESS';
export const ADD_MERCHANT_ACCOUNT_ERROR = 'ADD_MERCHANT_ACCOUNT_ERROR';
export const DELETE_MERCHANT_ACCOUNT_INIT = 'DELETE_MERCHANT_ACCOUNT_INIT';
export const DELETE_MERCHANT_ACCOUNT_SUCCESS = 'DELETE_MERCHANT_ACCOUNT_SUCCESS';
export const DELETE_MERCHANT_ACCOUNT_ERROR = 'DELETE_MERCHANT_ACCOUNT_ERROR';

export const FETCH_USER_MERCHANT_ACCOUNTS_INIT = 'FETCH_USER_MERCHANT_ACCOUNTS_INIT';
export const FETCH_USER_MERCHANT_ACCOUNTS_SUCCESS = 'FETCH_USER_MERCHANT_ACCOUNTS_SUCCESS';
export const FETCH_USER_MERCHANT_ACCOUNTS_ERROR = 'FETCH_USER_MERCHANT_ACCOUNTS_ERROR';

export const DOWNLOAD_SETTLEMENTS_INIT = 'DOWNLOAD_SETTLEMENTS_INIT';
export const DOWNLOAD_SETTLEMENTS_SUCCESS = 'DOWNLOAD_SETTLEMENTS_SUCCESS';
export const DOWNLOAD_SETTLEMENTS_ERROR = 'DOWNLOAD_SETTLEMENTS_ERROR';

// SETTLEMENT REPORTS
export const CREATE_SETTLEMENT_REPORT_INIT = 'CREATE_SETTLEMENT_REPORT_INIT';
export const CREATE_SETTLEMENT_REPORT_SUCCESS = 'CREATE_SETTLEMENT_REPORT_SUCCESS';
export const CREATE_SETTLEMENT_REPORT_ERROR = 'CREATE_SETTLEMENT_REPORT_ERROR';

export const FETCH_SETTLEMENT_REPORT_INIT = 'FETCH_SETTLEMENT_REPORT_INIT';
export const FETCH_SETTLEMENT_REPORT_SUCCESS = 'FETCH_SETTLEMENT_REPORT_SUCCESS';
export const FETCH_SETTLEMENT_REPORT_ERROR = 'FETCH_SETTLEMENT_REPORT_ERROR';

export const DELETE_SETTLEMENT_REPORT_INIT = 'DELETE_SETTLEMENT_REPORT_INIT';
export const DELETE_SETTLEMENT_REPORT_SUCCESS = 'DELETE_SETTLEMENT_REPORT_SUCCESS';
export const DELETE_SETTLEMENT_REPORT_ERROR = 'DELETE_SETTLEMENT_REPORT_ERROR';

export const UPDATE_SETTLEMENT_REPORT_INIT = 'UPDATE_SETTLEMENT_REPORT_INIT';
export const UPDATE_SETTLEMENT_REPORT_SUCCESS = 'UPDATE_SETTLEMENT_REPORT_SUCCESS';
export const UPDATE_SETTLEMENT_REPORT_ERROR = 'UPDATE_SETTLEMENT_REPORT_ERROR';

// PROCESSORS
export const FETCH_PROCESSORS_START = 'FETCH_PROCESSORS_START';
export const FETCH_PROCESSORS_SUCCESS = 'FETCH_PROCESSORS_SUCCESS';
export const FETCH_PROCESSORS_ERROR = 'FETCH_PROCESSORS_ERROR';
export const SELECT_PROCESSOR = 'SELECT_PROCESSOR';

export const FETCH_PROCESSOR_START = 'FETCH_PROCESSOR_START';
export const FETCH_PROCESSOR_SUCCESS = 'FETCH_PROCESSOR_SUCCESS';
export const FETCH_PROCESSOR_ERROR = 'FETCH_PROCESSOR_ERROR';

export const FETCH_PROCESSOR_TRANS_STATS_START = 'FETCH_PROCESSOR_TRANS_STATS_START';
export const FETCH_PROCESSOR_TRANS_STATS_SUCCESS = 'FETCH_PROCESSOR_TRANS_STATS_SUCCESS';
export const FETCH_PROCESSOR_TRANS_STATS_ERROR = 'FETCH_PROCESSOR_TRANS_STATS_ERROR';

export const ADD_PROCESSOR_START = 'ADD_PROCESSOR_START';
export const ADD_PROCESSOR_SUCCESS = 'ADD_PROCESSOR_SUCCESS';
export const ADD_PROCESSOR_ERROR = 'ADD_PROCESSOR_ERROR';

export const DELETE_PROCESSOR_START = 'DELETE_PROCESSOR_START';
export const DELETE_PROCESSOR_SUCCESS = 'DELETE_PROCESSOR_SUCCESS';
export const DELETE_PROCESSOR_ERROR = 'DELETE_PROCESSOR_ERROR';

export const UPDATE_PROCESSOR_START = 'UPDATE_PROCESSOR_START';
export const UPDATE_PROCESSOR_SUCCESS = 'UPDATE_PROCESSOR_SUCCESS';
export const UPDATE_PROCESSOR_ERROR = 'UPDATE_PROCESSOR_ERROR';

// MERCHANT_BENEFICIARIES
export const FETCH_MERCHANT_BENEFICIARIES_INIT = 'FETCH_MERCHANT_BENEFICIARIES_INIT';
export const FETCH_MERCHANT_BENEFICIARIES_SUCCESS = 'FETCH_MERCHANT_BENEFICIARIES_SUCCESS';
export const FETCH_MERCHANT_BENEFICIARIES_ERROR = 'FETCH_MERCHANT_BENEFICIARIES_ERROR';
export const CREATE_MERCHANT_BENEFICIARY_INIT = 'CREATE_MERCHANT_BENEFICIARY_INIT';
export const CREATE_MERCHANT_BENEFICIARY_SUCCESS = 'CREATE_MERCHANT_BENEFICIARY_SUCCESS';
export const CREATE_MERCHANT_BENEFICIARY_ERROR = 'CREATE_MERCHANT_BENEFICIARY_ERROR';
export const UPDATE_MERCHANT_BENEFICIARY_INIT = 'UPDATE_MERCHANT_BENEFICIARY_INIT';
export const UPDATE_MERCHANT_BENEFICIARY_SUCCESS = 'UPDATE_MERCHANT_BENEFICIARY_SUCCESS';
export const UPDATE_MERCHANT_BENEFICIARY_ERROR = 'UPDATE_MERCHANT_BENEFICIARY_ERROR';
export const DELETE_MERCHANT_BENEFICIARY_INIT = 'DELETE_MERCHANT_BENEFICIARY_INIT';
export const DELETE_MERCHANT_BENEFICIARY_SUCCESS = 'DELETE_MERCHANT_BENEFICIARY_SUCCESS';
export const DELETE_MERCHANT_BENEFICIARY_ERROR = 'DELETE_MERCHANT_BENEFICIARY_ERROR';
export const SEARCH_MERCHANT_ACCOUNTS = 'SEARCH_MERCHANT_ACCOUNTS';
export const SEARCH_PROCESSORS = 'SEARCH_PROCESSORS';
export const UPDATE_API_TOKEN_INIT = 'UPDATE_API_TOKEN_INIT';
export const UPDATE_API_TOKEN_SUCCESS = 'UPDATE_API_TOKEN_SUCCESS';
export const UPDATE_API_TOKEN_ERROR = 'UPDATE_API_TOKEN_ERROR';
export const FETCH_API_TOKENS_INIT = 'FETCH_API_TOKENS_INIT';
export const FETCH_API_TOKENS_SUCCESS = 'FETCH_API_TOKENS_SUCCESS';
export const FETCH_API_TOKENS_ERROR = 'FETCH_API_TOKENS_ERROR';
export const FETCH_SETTLEMENTS_INIT = 'FETCH_SETTLEMENTS_INIT';
export const FETCH_SETTLEMENTS_SUCCESS = 'FETCH_SETTLEMENTS_SUCCESS';
export const FETCH_SETTLEMENTS_ERROR = 'FETCH_SETTLEMENTS_ERROR';

export const APPROVE_SETTLEMENTS_INIT = 'APPROVE_SETTLEMENTS_INIT';
export const APPROVE_SETTLEMENTS_SUCCESS = 'APPROVE_SETTLEMENTS_SUCCESS';
export const APPROVE_SETTLEMENTS_ERROR = 'APPROVE_SETTLEMENTS_ERROR';

export const FETCH_WALLETS_INIT = 'FETCH_WALLETS_INIT';
export const FETCH_WALLETS_SUCCESS = 'FETCH_WALLETS_SUCCESS';
export const FETCH_WALLETS_ERROR = 'FETCH_WALLETS_ERROR';
export const FETCH_MERCHANT_TRANSACTIONS_INIT = 'FETCH_MERCHANT_TRANSACTIONS_INIT';
export const FETCH_MERCHANT_TRANSACTIONS_SUCCESS = 'FETCH_MERCHANT_TRANSACTIONS_SUCCESS';
export const FETCH_MERCHANT_TRANSACTIONS_ERROR = 'FETCH_MERCHANT_TRANSACTIONS_ERROR';

export const FETCH_TRANSACTION_SUMMARY_INIT = 'FETCH_TRANSACTION_SUMMARY_INIT';
export const FETCH_TRANSACTION_SUMMARY_VOLUME_SUCCESS = 'FETCH_TRANSACTION_SUMMARY_VOLUME_SUCCESS';
export const FETCH_TRANSACTION_SUMMARY_VOLUME_FAILED = 'FETCH_TRANSACTION_SUMMARY_VOLUME_FAILED';
export const FETCH_TRANSACTION_SUMMARY_VOLUME_ALL = 'FETCH_TRANSACTION_SUMMARY_VOLUME_ALL';
export const FETCH_TRANSACTION_SUMMARY_VOLUME_TODAY = 'FETCH_TRANSACTION_SUMMARY_VOLUME_TODAY';
export const FETCH_TRANSACTION_SUMMARY_VOLUME_THIS_MONTH = 'FETCH_TRANSACTION_SUMMARY_VOLUME_THIS_MONTH';
export const FETCH_TRANSACTION_SUMMARY_VOLUME_YESTERDAY = 'FETCH_TRANSACTION_SUMMARY_VOLUME_YESTERDAY';
export const FETCH_TRANSACTION_SUMMARY_VOLUME_LAST_MONTH = 'FETCH_TRANSACTION_SUMMARY_VOLUME_LAST_MONTH';
export const FETCH_TRANSACTION_SUMMARY_ERROR = 'FETCH_TRANSACTION_SUMMARY_ERROR';

export const FETCH_TRANSACTION_PROCESSED_INIT = 'FETCH_TRANSACTION_PROCESSED_INIT';
export const FETCH_TRANSACTION_PROCESSED = 'FETCH_TRANSACTION_PROCESSED';
export const FETCH_TRANSACTION_PROCESSED_ERROR = 'FETCH_TRANSACTION_PROCESSED_ERROR';

export const FETCH_TRANSACTIONS_INIT = 'FETCH_TRANSACTIONS_INIT';
export const FETCH_TRANSACTIONS_SUCCESS = 'FETCH_TRANSACTIONS_SUCCESS';
export const FETCH_TRANSACTIONS_ERROR = 'FETCH_TRANSACTIONS_ERROR';

export const CHECK_TRANSACTION_STATUS_INIT = 'CHECK_TRANSACTION_STATUS_INIT';
export const CHECK_TRANSACTION_STATUS_SUCCESS = 'CHECK_TRANSACTION_STATUS_SUCCESS';
export const CHECK_TRANSACTION_STATUS_ERROR = 'CHECK_TRANSACTION_STATUS_ERROR';

export const DOWNLOAD_TRANSACTIONS_INIT = 'DOWNLOAD_TRANSACTIONS_INIT';
export const DOWNLOAD_TRANSACTIONS_SUCCESS = 'DOWNLOAD_TRANSACTIONS_SUCCESS';
export const DOWNLOAD_TRANSACTIONS_ERROR = 'DOWNLOAD_TRANSACTIONS_ERROR';

export const FETCH_MERCHANT_RECENT_TRANSACTIONS_SUCCESS = 'FETCH_MERCHANT_RECENT_TRANSACTIONS_SUCCESS';

export const FETCH_DUPLICATE_TRANSACTIONS_INIT = 'FETCH_DUPLICATE_TRANSACTIONS_INIT';
export const FETCH_DUPLICATE_TRANSACTIONS_SUCCESS = 'FETCH_DUPLICATE_TRANSACTIONS_SUCCESS';
export const FETCH_DUPLICATE_TRANSACTIONS_ERROR = 'FETCH_DUPLICATE_TRANSACTIONS_ERROR';

export const FETCH_WALLETS_AGG_BALANCE_INIT = 'FETCH_WALLETS_AGG_BALANCE_INIT';
export const FETCH_WALLETS_AGG_BALANCE_SUCCESS = 'FETCH_WALLETS_AGG_BALANCE_SUCCESS';
export const FETCH_WALLETS_AGG_BALANCE_ERROR = 'FETCH_WALLETS_AGG_BALANCE_ERROR';

export const FETCH_WALLETS_AGG_ROLLING_RESERVE_INIT = 'FETCH_WALLETS_AGG_ROLLING_RESERVE_INIT';
export const FETCH_WALLETS_AGG_ROLLING_RESERVE_SUCCESS = 'FETCH_WALLETS_AGG_ROLLING_RESERVE_SUCCESS';
export const FETCH_WALLETS_AGG_ROLLING_RESERVE_ERROR = 'FETCH_WALLETS_AGG_ROLLING_RESERVE_ERROR';

export const FETCH_WALLET_OVERVIEW_INIT = 'FETCH_WALLET_OVERVIEW_INIT';
export const FETCH_WALLET_OVERVIEW_SUCCESS = 'FETCH_WALLET_OVERVIEW_SUCCESS';
export const FETCH_WALLET_OVERVIEW_ERROR = 'FETCH_WALLET_OVERVIEW_ERROR';

export const FETCH_WALLET_OVERVIEW_PER_PSP_INIT = 'FETCH_WALLET_OVERVIEW_PER_PSP_INIT';
export const FETCH_WALLET_OVERVIEW_PER_PSP_SUCCESS = 'FETCH_WALLET_OVERVIEW_PER_PSP_SUCCESS';
export const FETCH_WALLET_OVERVIEW_PER_PSP_ERROR = 'FETCH_WALLET_OVERVIEW_PER_PSP_ERROR';

// TRANSACTION CHARGES
export const FETCH_TRANSACTION_CHARGES_START = 'FETCH_TRANSACTION_CHARGES_START';
export const FETCH_TRANSACTION_CHARGES_SUCCESS = 'FETCH_TRANSACTION_CHARGES_SUCCESS';
export const FETCH_TRANSACTION_CHARGES_ERROR = 'FETCH_TRANSACTION_CHARGES_ERROR';

export const FETCH_PROCESSING_FEE_TEST_CLEAR = 'FETCH_PROCESSING_FEE_TEST_CLEAR';

export const ADD_TRANSACTION_CHARGE_START = 'ADD_TRANSACTION_CHARGE_START';
export const ADD_TRANSACTION_CHARGE_SUCCESS = 'ADD_TRANSACTION_CHARGE_SUCCESS';
export const ADD_TRANSACTION_CHARGE_ERROR = 'ADD_TRANSACTION_CHARGE_ERROR';

export const DELETE_TRANSACTION_CHARGE_START = 'DELETE_TRANSACTION_CHARGE_START';
export const DELETE_TRANSACTION_CHARGE_SUCCESS = 'DELETE_TRANSACTION_CHARGE_SUCCESS';
export const DELETE_TRANSACTION_CHARGE_ERROR = 'DELETE_TRANSACTION_CHARGE_ERROR';

export const UPDATE_TRANSACTION_CHARGE_START = 'UPDATE_TRANSACTION_CHARGE_START';
export const UPDATE_TRANSACTION_CHARGE_SUCCESS = 'UPDATE_TRANSACTION_CHARGE_SUCCESS';
export const UPDATE_TRANSACTION_CHARGE_ERROR = 'UPDATE_TRANSACTION_CHARGE_ERROR';

// VERIFY RECAPTCHA
export const FETCH_RECAPTCHA_INIT = 'FETCH_RECAPTCHA_INIT';
export const FETCH_RECAPTCHA_SUCCESS = 'FETCH_RECAPTCHA_SUCCESS';
export const FETCH_RECAPTCHA_ERROR = 'FETCH_RECAPTCHA_ERROR';

// VERIFY MFA TOKEN
export const VERIFY_MFA_TOKEN_START = 'VERIFY_MFA_TOKEN_START';
export const VERIFY_MFA_TOKEN_SUCCESS = 'VERIFY_MFA_TOKEN_SUCCESS';
export const VERIFY_MFA_TOKEN_ERROR = 'VERIFY_MFA_TOKEN_ERROR';

// QRCODE
export const GET_MFA_QRCODE_START = ' GET_MFA_QRCODE_START';
export const GET_MFA_QRCODE_SUCCESS = ' GET_MFA_QRCODE_SUCCESS';
export const GET_MFA_QRCODE_ERROR = ' GET_MFA_QRCODE_ERROR';

// TOGGLE MFA
export const TOGGLE_MFA_TOKEN_START = 'TOGGLE_MFA_TOKEN_START';
export const TOGGLE_MFA_TOKEN_SUCCESS = 'TOGGLE_MFA_TOKEN_SUCCESS';
export const TOGGLE_MFA_TOKEN_ERROR = 'TOGGLE_MFA_TOKEN_ERROR';

// TRANSACTION SUMMARY
export const DOWNLOAD_SUMMARY_INIT = 'DOWNLOAD_SUMMARY_INIT';
export const DOWNLOAD_SUMMARY_SUCCESS = 'DOWNLOAD_SUMMARY_SUCCESS';
export const DOWNLOAD_SUMMARY_ERROR = 'DOWNLOAD_SUMMARY_ERROR';

// FDS_CARDS
export const FETCH_FDS_CARDS_START = 'FETCH_FDS_CARDS_START';
export const FETCH_FDS_CARDS_SUCCESS = 'FETCH_FDS_CARDS_SUCCESS';
export const FETCH_FDS_CARDS_ERROR = 'FETCH_FDS_CARDS_ERROR';

export const ADD_FDS_CARD_START = 'ADD_FDS_CARD_START';
export const ADD_FDS_CARD_SUCCESS = 'ADD_FDS_CARD_SUCCESS';
export const ADD_FDS_CARD_ERROR = 'ADD_FDS_CARD_ERROR';

export const UPDATE_FDS_CARD_START = 'UPDATE_FDS_CARD_START';
export const UPDATE_FDS_CARD_SUCCESS = 'UPDATE_FDS_CARD_SUCCESS';
export const UPDATE_FDS_CARD_ERROR = 'UPDATE_FDS_CARD_ERROR';


// TRAFFIC_WEBSITES
export const FETCH_TRAFFIC_WEBSITES_START = 'FETCH_TRAFFIC_WEBSITES_START';
export const FETCH_TRAFFIC_WEBSITES_SUCCESS = 'FETCH_TRAFFIC_WEBSITES_SUCCESS';
export const FETCH_TRAFFIC_WEBSITES_ERROR = 'FETCH_TRAFFIC_WEBSITES_ERROR';

export const ADD_TRAFFIC_WEBSITE_START = 'ADD_TRAFFIC_WEBSITE_START';
export const ADD_TRAFFIC_WEBSITE_SUCCESS = 'ADD_TRAFFIC_WEBSITE_SUCCESS';
export const ADD_TRAFFIC_WEBSITE_ERROR = 'ADD_TRAFFIC_WEBSITE_ERROR';

export const UPDATE_TRAFFIC_WEBSITE_START = 'UPDATE_TRAFFIC_WEBSITE_START';
export const UPDATE_TRAFFIC_WEBSITE_SUCCESS = 'UPDATE_TRAFFIC_WEBSITE_SUCCESS';
export const UPDATE_TRAFFIC_WEBSITE_ERROR = 'UPDATE_TRAFFIC_WEBSITE_ERROR';

// WEBHOOKS
export const TRIGGER_WEBHOOK_INIT = 'TRIGGER_WEBHOOK_INIT';
export const TRIGGER_WEBHOOK_SUCCESS = 'TRIGGER_WEBHOOK_SUCCESS';
export const TRIGGER_WEBHOOK_ERROR = 'TRIGGER_WEBHOOK_ERROR';

// Generate API Action Types
export const GENERATE_API_KEY_INIT = 'GENERATE_API_KEY_INIT';
export const GENERATE_API_KEY_SUCCESS = 'GENERATE_API_KEY_SUCCESS';
export const GENERATE_API_KEY_ERROR = 'GENERATE_API_KEY_ERROR';

export const UPDATE_API_KEY_INIT = 'UPDATE_API_KEY_INIT';
export const UPDATE_API_KEY_SUCCESS = 'UPDATE_API_KEY_SUCCESS';
export const UPDATE_API_KEY_ERROR = 'UPDATE_API_KEY_ERROR';

export const DELETE_API_KEY_INIT = 'DELETE_API_KEY_INIT';
export const DELETE_API_KEY_SUCCESS = 'DELETE_API_KEY_SUCCESS';
export const DELETE_API_KEY_ERROR = 'DELETE_API_KEY_ERROR';
export const FETCH_API_KEYS_INIT = 'FETCH_API_KEYS_INIT';
export const FETCH_API_KEYS_SUCCESS = 'FETCH_API_KEYS_SUCCESS';
export const FETCH_API_KEYS_ERROR = 'FETCH_API_KEYS_ERROR';

// Wallet Action Types
export const FETCH_USER_WALLETS_INIT = 'FETCH_USER_WALLETS_INIT';
export const FETCH_USER_WALLETS_SUCCESS = 'FETCH_USER_WALLETS_SUCCESS';
export const FETCH_USER_WALLETS_ERROR = 'FETCH_USER_WALLETS_ERROR';

// GATEWAY TRANSACTIONS
export const FETCH_GATEWAY_TRANSACTIONS_START = 'FETCH_GATEWAY_TRANSACTIONS_START';
export const FETCH_GATEWAY_TRANSACTIONS_SUCCESS = 'FETCH_GATEWAY_TRANSACTIONS_SUCCESS';
export const FETCH_GATEWAY_TRANSACTIONS_ERROR = 'FETCH_GATEWAY_TRANSACTIONS_ERROR';

export const FETCH_GATEWAY_TRANSACTION_START = 'FETCH_GATEWAY_TRANSACTION_START';
export const FETCH_GATEWAY_TRANSACTION_SUCCESS = 'FETCH_GATEWAY_TRANSACTION_SUCCESS';
export const FETCH_GATEWAY_TRANSACTION_ERROR = 'FETCH_GATEWAY_TRANSACTION_ERROR';

// GATEWAY CALLBACKS
export const FETCH_GATEWAY_CALLBACKS_START = 'FETCH_GATEWAY_CALLBACKS_START';
export const FETCH_GATEWAY_CALLBACKS_SUCCESS = 'FETCH_GATEWAY_CALLBACKS_SUCCESS';
export const FETCH_GATEWAY_CALLBACKS_ERROR = 'FETCH_GATEWAY_CALLBACKS_ERROR';

// GATEWAY SUSPICIOUS_LOGS
export const FETCH_GATEWAY_SUSPICIOUS_LOGS_START = 'FETCH_GATEWAY_SUSPICIOUS_LOGS_START';
export const FETCH_GATEWAY_SUSPICIOUS_LOGS_SUCCESS = 'FETCH_GATEWAY_SUSPICIOUS_LOGS_SUCCESS';
export const FETCH_GATEWAY_SUSPICIOUS_LOGS_ERROR = 'FETCH_GATEWAY_SUSPICIOUS_LOGS_ERROR';

// GATEWAY IPNS
export const FETCH_GATEWAY_IPNS_START = 'FETCH_GATEWAY_IPNS_START';
export const FETCH_GATEWAY_IPNS_SUCCESS = 'FETCH_GATEWAY_IPNS_SUCCESS';
export const FETCH_GATEWAY_IPNS_ERROR = 'FETCH_GATEWAY_IPNS_ERROR';

export const FETCH_GATEWAY_IPN_START = 'FETCH_GATEWAY_IPN_START';
export const FETCH_GATEWAY_IPN_SUCCESS = 'FETCH_GATEWAY_IPN_SUCCESS';
export const FETCH_GATEWAY_IPN_ERROR = 'FETCH_GATEWAY_IPN_ERROR';
export const DOWNLOAD_IPNS_ERROR = 'DOWNLOAD_IPNS_ERROR';
export const DOWNLOAD_IPNS_SUCCESS = 'DOWNLOAD_IPNS_SUCCESS';
export const DOWNLOAD_IPNS_INIT = 'DOWNLOAD_IPNS_INIT';

// EVENTS
export const FETCH_EVENT_LOG_START = 'FETCH_EVENT_LOG_START';
export const FETCH_EVENT_LOG_SUCCESS = 'FETCH_EVENT_LOG_SUCCESS';
export const FETCH_EVENT_LOG_ERROR = 'FETCH_EVENT_LOG_ERROR';

export const FETCH_EVENT_LOGS_START = 'FETCH_EVENT_LOGS_START';
export const FETCH_EVENT_LOGS_SUCCESS = 'FETCH_EVENT_LOGS_SUCCESS';
export const FETCH_EVENT_LOGS_ERROR = 'FETCH_EVENT_LOGS_ERROR';

// TIMELINE
export const FETCH_TIMELINE_LOG_START = 'FETCH_TIMELINE_LOG_START';
export const FETCH_TIMELINE_LOG_SUCCESS = 'FETCH_TIMELINE_LOG_SUCCESS';
export const FETCH_TIMELINE_LOG_ERROR = 'FETCH_TIMELINE_LOG_ERROR';
export const FETCH_TIMELINE_LOGS_START = 'FETCH_TIMELINE_LOGS_START';
export const FETCH_TIMELINE_LOGS_SUCCESS = 'FETCH_TIMELINE_LOGS_SUCCESS';
export const FETCH_TIMELINE_LOGS_ERROR = 'FETCH_TIMELINE_LOGS_ERROR';

// GATEWAY TRANSACTIONS
export const FETCH_GATEWAY_TRANSACTION_LOG_START = 'FETCH_GATEWAY_TRANSACTION_LOG_START';
export const FETCH_GATEWAY_TRANSACTION_LOG_SUCCESS = 'FETCH_GATEWAY_TRANSACTION_LOG_SUCCESS';
export const FETCH_GATEWAY_TRANSACTION_LOG_ERROR = 'FETCH_GATEWAY_TRANSACTION_LOG_ERROR';

export const FETCH_GATEWAY_TRANSACTION_LOGS_START = 'FETCH_GATEWAY_TRANSACTION_LOGS_START';
export const FETCH_GATEWAY_TRANSACTION_LOGS_SUCCESS = 'FETCH_GATEWAY_TRANSACTION_LOGS_SUCCESS';
export const FETCH_GATEWAY_TRANSACTION_LOGS_ERROR = 'FETCH_GATEWAY_TRANSACTION_LOGS_ERROR';


/*** AGGREGATE SERVICE */
// General
export const FETCH_GENERAL_TOTAL_START = 'FETCH_GENERAL_TOTAL_START';
export const FETCH_GENERAL_TOTAL_SUCCESS = 'FETCH_GENERAL_TOTAL_SUCCESS';
export const FETCH_GENERAL_EUR_TOTAL_DAILY_SUCCESS = 'FETCH_GENERAL_EUR_TOTAL_DAILY_SUCCESS';
export const FETCH_GENERAL_USD_TOTAL_DAILY_SUCCESS = 'FETCH_GENERAL_USD_TOTAL_DAILY_SUCCESS';
export const FETCH_GENERAL_TOTAL_DAILY_THIS_MONTH_SUCCESS = 'FETCH_GENERAL_TOTAL_DAILY_THIS_MONTH_SUCCESS';
export const FETCH_GENERAL_TOTAL_DAILY_LAST_MONTH_SUCCESS = 'FETCH_GENERAL_TOTAL_DAILY_LAST_MONTH_SUCCESS';
export const FETCH_GENERAL_TOTAL_HOURLY_SUCCESS = 'FETCH_GENERAL_TOTAL_HOURLY_SUCCESS';
export const FETCH_GENERAL_USD_TOTAL_HOURLY_SUCCESS = 'FETCH_GENERAL_USD_TOTAL_HOURLY_SUCCESS';
export const FETCH_GENERAL_EUR_TOTAL_HOURLY_SUCCESS = 'FETCH_GENERAL_EUR_TOTAL_HOURLY_SUCCESS';
export const FETCH_GENERAL_TOTAL_MONTH_SUCCESS = 'FETCH_GENERAL_TOTAL_MONTH_SUCCESS';
export const FETCH_GENERAL_TOTAL_THIS_MONTH_SUCCESS = 'FETCH_GENERAL_TOTAL_THIS_MONTH_SUCCESS';
export const FETCH_GENERAL_TOTAL_LAST_MONTH_SUCCESS = 'FETCH_GENERAL_TOTAL_LAST_MONTH_SUCCESS';
export const FETCH_GENERAL_USD_TOTAL_MONTH_SUCCESS = 'FETCH_GENERAL_USD_TOTAL_MONTH_SUCCESS';
export const FETCH_GENERAL_TOTAL_ERROR = 'FETCH_GENERAL_TOTAL_ERROR';

export const FETCH_GENERAL_TOTAL_CUMULATIVE_START = 'FETCH_GENERAL_TOTAL_CUMULATIVE_START';
export const FETCH_GENERAL_TOTAL_CUMULATIVE_SUCCESS = 'FETCH_GENERAL_TOTAL_CUMULATIVE_SUCCESS';
export const FETCH_GENERAL_TOTAL_CUMULATIVE_ERROR = 'FETCH_GENERAL_TOTAL_CUMULATIVE_ERROR';

export const FETCH_GENERAL_TOTAL_TODAY_CUMULATIVE_SUCCESS = 'FETCH_GENERAL_TOTAL_TODAY_CUMULATIVE_SUCCESS';
export const FETCH_GENERAL_USD_TOTAL_TODAY_CUMULATIVE_SUCCESS = 'FETCH_GENERAL_USD_TOTAL_TODAY_CUMULATIVE_SUCCESS';
export const FETCH_GENERAL_EUR_TOTAL_TODAY_CUMULATIVE_SUCCESS = 'FETCH_GENERAL_EUR_TOTAL_TODAY_CUMULATIVE_SUCCESS';
export const FETCH_GENERAL_USD_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS = 'FETCH_GENERAL_USD_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS';
export const FETCH_GENERAL_EUR_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS = 'FETCH_GENERAL_EUR_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS';

export const FETCH_GENERAL_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS = 'FETCH_GENERAL_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS';
export const FETCH_GENERAL_TOTAL_THIS_MONTH_CUMULATIVE_SUCCESS = 'FETCH_GENERAL_TOTAL_THIS_MONTH_CUMULATIVE_SUCCESS';
export const FETCH_GENERAL_TOTAL_LAST_MONTH_CUMULATIVE_SUCCESS = 'FETCH_GENERAL_TOTAL_LAST_MONTH_CUMULATIVE_SUCCESS';


// Merchant
export const FETCH_MERCHANT_TOTAL_START = 'FETCH_MERCHANT_TOTAL_START';
export const FETCH_MERCHANT_TOTAL_SUCCESS = 'FETCH_MERCHANT_TOTAL_SUCCESS';
export const FETCH_MERCHANT_EUR_TOTAL_DAILY_SUCCESS = 'FETCH_MERCHANT_EUR_TOTAL_DAILY_SUCCESS';
export const FETCH_MERCHANT_USD_TOTAL_DAILY_SUCCESS = 'FETCH_MERCHANT_USD_TOTAL_DAILY_SUCCESS';
export const FETCH_MERCHANT_TOTAL_DAILY_THIS_MONTH_SUCCESS = 'FETCH_MERCHANT_TOTAL_DAILY_THIS_MONTH_SUCCESS';
export const FETCH_MERCHANT_TOTAL_DAILY_LAST_MONTH_SUCCESS = 'FETCH_MERCHANT_TOTAL_DAILY_LAST_MONTH_SUCCESS';
export const FETCH_MERCHANT_TOTAL_HOURLY_SUCCESS = 'FETCH_MERCHANT_TOTAL_HOURLY_SUCCESS';
export const FETCH_MERCHANT_USD_TOTAL_HOURLY_SUCCESS = 'FETCH_MERCHANT_USD_TOTAL_HOURLY_SUCCESS';
export const FETCH_MERCHANT_EUR_TOTAL_HOURLY_SUCCESS = 'FETCH_MERCHANT_EUR_TOTAL_HOURLY_SUCCESS';
export const FETCH_MERCHANT_TOTAL_MONTH_SUCCESS = 'FETCH_MERCHANT_TOTAL_MONTH_SUCCESS';
export const FETCH_MERCHANT_TOTAL_THIS_MONTH_SUCCESS = 'FETCH_MERCHANT_TOTAL_THIS_MONTH_SUCCESS';
export const FETCH_MERCHANT_TOTAL_LAST_MONTH_SUCCESS = 'FETCH_MERCHANT_TOTAL_LAST_MONTH_SUCCESS';
export const FETCH_MERCHANT_USD_TOTAL_MONTH_SUCCESS = 'FETCH_MERCHANT_USD_TOTAL_MONTH_SUCCESS';
export const FETCH_MERCHANT_TOTAL_ERROR = 'FETCH_MERCHANT_TOTAL_ERROR';

export const FETCH_MERCHANT_TOTAL_CUMULATIVE_START = 'FETCH_MERCHANT_TOTAL_CUMULATIVE_START';
export const FETCH_MERCHANT_TOTAL_CUMULATIVE_SUCCESS = 'FETCH_MERCHANT_TOTAL_CUMULATIVE_SUCCESS';
export const FETCH_MERCHANT_TOTAL_CUMULATIVE_ERROR = 'FETCH_MERCHANT_TOTAL_CUMULATIVE_ERROR';

export const FETCH_MERCHANT_TOTAL_TODAY_CUMULATIVE_SUCCESS = 'FETCH_MERCHANT_TOTAL_TODAY_CUMULATIVE_SUCCESS';
export const FETCH_MERCHANT_USD_TOTAL_TODAY_CUMULATIVE_SUCCESS = 'FETCH_MERCHANT_USD_TOTAL_TODAY_CUMULATIVE_SUCCESS';
export const FETCH_MERCHANT_EUR_TOTAL_TODAY_CUMULATIVE_SUCCESS = 'FETCH_MERCHANT_EUR_TOTAL_TODAY_CUMULATIVE_SUCCESS';
export const FETCH_MERCHANT_USD_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS = 'FETCH_MERCHANT_USD_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS';
export const FETCH_MERCHANT_EUR_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS = 'FETCH_MERCHANT_EUR_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS';

export const FETCH_MERCHANT_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS = 'FETCH_MERCHANT_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS';
export const FETCH_MERCHANT_TOTAL_THIS_MONTH_CUMULATIVE_SUCCESS = 'FETCH_MERCHANT_TOTAL_THIS_MONTH_CUMULATIVE_SUCCESS';
export const FETCH_MERCHANT_TOTAL_LAST_MONTH_CUMULATIVE_SUCCESS = 'FETCH_MERCHANT_TOTAL_LAST_MONTH_CUMULATIVE_SUCCESS';



/** End Aggregate */

export const FETCH_PROCESSOR_TOTAL_START = 'FETCH_PROCESSOR_TOTAL_START';
export const FETCH_PROCESSOR_TOTAL_SUCCESS = 'FETCH_PROCESSOR_TOTAL_SUCCESS';
export const FETCH_PROCESSOR_TOTAL_ERROR = 'FETCH_PROCESSOR_TOTAL_ERROR';



